<template>
    <div class="rd">
        <div class="pagina">
            <header class="paginakop">
                <div class="tekst">
                    <h1>General information</h1>
                    <p>Shared material for all operators.</p>
                </div>
            </header>

            <p v-if="loading" class="rd-laden">Loading information...</p>
            <section v-else-if="contentBlocks.length > 0" class="paneel">
                <div class="cb-inhoud">
                    <render-content-blocks :content-blocks="contentBlocks" />
                </div>
            </section>
            <div v-else class="leeg">
                <h2>Nothing here yet</h2>
                <p>X-Cube will add shared operator material here.</p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { getContentBlocks } from "../../api/rest";
import RenderContentBlocks from "../content-block/RenderContentBlocks.vue";

const contentBlocks = ref([]);
const loading = ref(true);

onMounted(async () => {
    try {
        contentBlocks.value = await getContentBlocks("operator-info");
    } finally {
        loading.value = false;
    }
});
</script>
